module.exports = __webpack_public_path__ + "img/map.acb09580.jpg";